import React, { useEffect, useState } from 'react';
import Search from '../../components/input/Search';
import AddCityModal from './components/AddCityModal';
import { deleteCity, searchCities } from '../../api/sportaloka-client';
import CityTable from './components/CityTable';
import Swal from 'sweetalert2';
import UpdateCityModal from './components/UpdateCityModal';
import SelectProvince from '../../components/input/SelectProvince';

function City() {
  const [selectedData, setSelectedData] = useState(null);
  const [cities, setCities] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'updated_at',
    sort_value: 'desc',
    name: '',
    province: null
  });

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setCities([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        name: paginationOptions.name,
        province_id: paginationOptions.province ? paginationOptions.province.value : ''
      }).toString();
      const response = await searchCities(query);
      const responseData = response.data.data.data;
      setCities(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const handleDelete = (val) => {
    Swal.fire({
      title: 'Apakah anda yakin ingin menghapus data?',
      text: 'Data yang dihapus tidak dapat dikembalikan, pastikan anda sudah yakin dengan aksi ini.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, hapus data!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setCities([]);
          await deleteCity(val);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: 'Data berhasil dihapus.',
            icon: 'success'
          });
        } catch (error) {
          if (error.response && error.response.data.code === '100403') {
            Swal.fire({
              title: 'Gagal!',
              text: 'Data ini digunakan oleh data yang berelasi.',
              icon: 'error',
              confirmButtonText: 'Tutup'
            });
          } else {
            Swal.fire({
              title: 'Gagal!',
              text: 'Periksa koneksi anda dan coba kembali.',
              icon: 'error',
              confirmButtonText: 'Tutup'
            });
          }
          await getData();
          setLoading(false);
        }
      }
    });
  };

  const handleSort = (field) => {
    const isAsc = paginationOptions.sort_field === field && paginationOptions.sort_value === 'asc';
    setPaginationOptions({
      ...paginationOptions,
      sort_field: field,
      sort_value: isAsc ? 'desc' : 'asc',
      page: 1
    });
  };

  const handleSubmit = () => {
    setPaginationOptions({ ...paginationOptions, page: 1 });
  };

  const handleSearch = (val) => {
    setPaginationOptions({ ...paginationOptions, name: val, page: 1 });
  };

  const handleFilter = (val) => {
    setPaginationOptions({ ...paginationOptions, province: val, page: 1 });
  };

  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">City Master</h1>
          <button
            type="button"
            className="button -md h-50 bg-blue-1 text-white"
            data-bs-toggle="modal"
            data-bs-target="#addCityModal">
            <i className="fa fa-plus mr-10" />
            Data Baru
          </button>
        </div>
        <div className="row mt-20 align-items-end">
          <div className="col-6">
            <Search onSearch={handleSearch} label="Nama Kota" />
          </div>
          <div className="col-6">
            <SelectProvince
              style="inline"
              isError={true}
              onChange={handleFilter}
              value={paginationOptions.province}
              placeholder="Semua Provinsi"
            />
          </div>
        </div>
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20">
          <CityTable
            handleSort={handleSort}
            handlePageChange={handlePageChange}
            onDelete={handleDelete}
            onSelectedData={(val) => {
              setSelectedData(null);
              setTimeout(() => {
                setSelectedData(val);
              }, 100);
            }}
            paginationOptions={paginationOptions}
            loading={loading}
            error={error}
            data={cities}
            handleRefresh={getData}
            totalRows={totalRows}
          />
        </div>
        <AddCityModal onSubmitted={handleSubmit} />
        <UpdateCityModal onSubmitted={handleSubmit} data={selectedData} />
      </div>
      {/* End .col-12 */}
    </div>
  );
}

export default City;
